+function ($) {
    'use strict';

    var Gallery = function (element, option) {
        this.$element = $(element);
        this.$prev = this.$element.find('.gallery__list__prev');
        this.$next = this.$element.find('.gallery__list__next');
        this.$wrapper = this.$element.find('.gallery__list__wrapper');
        this.$container = this.$element.find('.gallery__list__items');
        this.$items = this.$container.find('img');
        this.leftBody = 0;
        this.fontConstant = 3;

        this.template = "<div class='gallery__popup'><a href='#' class='gallery__group__close' title='закрыть окно'>x</a> <a href='#' class='gallery__popup__prev'></a><a href='#' class='gallery__popup__next'></a> <img src='' class='gallery__group__image'></div>";

        this.animate = false;

        var self = this;

        this.$next.bind('click', function () {
            self.next();
            return false;
        });

        this.$prev.bind('click', function () {
            self.prev();
            return false;
        });
        
        this.$items.bind('click', function () {
            self._showPopUp($(this).data('orig_img'), self.$items.index($(this)));
        });

        $(window).bind('resize', function () {
            self.normalize();
        });
    };

    Gallery.prototype._showPopUp = function (src, index) {
        this.$popup = $(this.template);
        this.popupShowedIndex = index;
        this.$popup.css('opacity', 0);
        this.$popup.find('img').attr('src', src);
        $('body').append(this.$popup);
        var self = this;
        this.$popup.find('.gallery__popup__prev').bind('click', function () {
            self.popupPrev();
            return false;
        });
        this.$popup.find('.gallery__popup__next').bind('click', function () {
            self.popupNext();
            return false;
        });
        var width = this.$popup.find('.gallery__group__close').outerWidth();
        this.$popup.find('.gallery__group__close').css('margin-left', -(width/2));
        this.$popup.find('.gallery__group__close').bind('click', function () {
            self._hidePopUp();
            return false;
        });

        this.$popup.bind('touchstart', function(ev){
            this.touchStartClientX = ev.originalEvent.changedTouches[0].clientX;
        });

        this.$popup.bind('touchend', function (ev) {
            this.touchEndClientX = ev.originalEvent.changedTouches[0].clientX;

            if (this.touchStartClientX > this.touchEndClientX) {
                self.popupNext();
            } else {
                self.popupPrev();
            }
        });


        this.$popup.animate({
            'opacity':1
        }, {
            'duration': 200,
            'easing': 'swing',
            'complete': function () {
                var height = self.$popup.find('img').height();
                self.$popup.find('img').animate({
                    'margin-top': -(height/2)
                }, {
                    'duration': 200,
                    'easing': 'swing',
                    'complete': function () {
                    }
                });
            }
        });
    };
    
    Gallery.prototype._hidePopUp = function () {
        if(this.$popup) {
            var self = this;
            this.$popup.animate({
                'opacity': 0,
            }, {
                'duration':200,
                'easing' : 'swing',
                'complete': function () {
                    self.normalize();
                }
            });
        }
    };

    Gallery.prototype.popupPrev = function () {
        if(this.$popup) {
            var length = this.$items.length;
            if(this.popupShowedIndex >= 0) {
                this.popupShowedIndex--;
                if(this.popupShowedIndex < 0) {
                    this.popupShowedIndex = this.$items.length-1;
                }

                var srcOrig = this.$items.eq(this.popupShowedIndex).data('orig_img');
                var width = this.$popup.find('.gallery__group__image').outerWidth();
                var widthScreen = $(document).width() / 2;
                var self = this;
                this.$popup.find('.gallery__group__image').animate({
                    'left': widthScreen+width,
                }, {
                    'duration': 200,
                    'easing': 'swing',
                    'complete': function () {
                        self.$popup.find('.gallery__group__image').bind('load', function() {
                            var width = self.$popup.find('.gallery__group__image').outerWidth();
                            self.$popup.find('.gallery__group__image').css('left', -(widthScreen+width)).animate({
                                'left':0,
                            }, {
                                'duration': 200,
                                'easing': 'swing',
                                'complete': function () {
                                    var height = self.$popup.find('img').height();
                                    self.$popup.find('img').animate({
                                        'margin-top':-(height/2),
                                    }, {
                                        'duration': 200,
                                        'easing': 'swing',
                                    });
                                }
                            });
                        });
                        
                        self.$popup.find('.gallery__group__image').attr('src', srcOrig);
                    }
                });
            }
        }
    };
    
    Gallery.prototype.popupNext = function () {
        if(this.$popup) {
            var length = this.$items.length;
            if(this.popupShowedIndex < length) {
                this.popupShowedIndex++;
                if(this.popupShowedIndex == length) {
                    this.popupShowedIndex = 0;
                }
                var srcOrig = this.$items.eq(this.popupShowedIndex).data('orig_img');
                var width = this.$popup.find('.gallery__group__image').outerWidth();
                var widthScreen = $(document).width() / 2;
                var self = this;
                this.$popup.find('.gallery__group__image').animate({
                    'left': -(widthScreen+width),
                }, {
                    'duration': 200,
                    'easing': 'swing',
                    'complete': function () {
                        self.$popup.find('.gallery__group__image').bind('load', function() {
                            var width = self.$popup.find('.gallery__group__image').outerWidth();
                            self.$popup.find('.gallery__group__image').css('left', (widthScreen+width)).animate({
                                'left':0,
                            }, {
                                'duration': 200,
                                'easing': 'swing',
                                'complete': function () {
                                    var height = self.$popup.find('img').height();
                                    self.$popup.find('img').animate({
                                        'margin-top':-(height/2),
                                    }, {
                                        'duration': 200,
                                        'easing': 'swing',
                                    });
                                }
                            });
                        });
                        self.$popup.find('.gallery__group__image').attr('src', srcOrig);
                    }
                });
            }
        }
    };

    Gallery.prototype.normalize = function () {
        this.$container.css('left', 0);
        this.leftBody = 0;

        $('body').find('.gallery__popup').remove();
        this.popup = null;
        this.popupShowedIndex = 0;
    };

    Gallery.prototype.next = function () {
        if(!this.animate) {
            this.animate = true;
            var widthSlide = this.$items.eq(1).outerWidth(true);
            widthSlide += this.fontConstant;
            var currentLeft = -this.leftBody;
            var widthWrapper = this.$wrapper.outerWidth();

            var amountInWrapper = widthWrapper/widthSlide;
            //Узнать сколько скрыто
            var amountSliders = this.$items.length;
            if (amountSliders > amountInWrapper) {
                var hiddenSlides = amountSliders - currentLeft/(widthSlide-this.fontConstant) - amountInWrapper;
                if (hiddenSlides > 0) {
                    currentLeft += widthSlide;
                    this.leftBody = -currentLeft;
                    var self = this;
                    this.$container.animate({
                        'left': -currentLeft,
                    }, {
                        'duration': 200,
                        'easing': 'swing',
                        'complete': function () {
                            self.animate = false;
                        }
                    });

                } else {
                    this.animate = false;
                }
            } else {
                this.animate = false;
            }
        }
    };

    Gallery.prototype.prev = function () {
        if(!this.animate) {
            this.animate = true;
            var widthSlide = this.$items.eq(1).outerWidth(true);
            widthSlide += this.fontConstant;
            var currentLeft = -this.leftBody;
            var widthWrapper = this.$wrapper.outerWidth();

            var amountInWrapper = widthWrapper/widthSlide;
            var amountSliders = this.$items.length;
            if (amountSliders > amountInWrapper) {
                var hiddenSlides = currentLeft/(widthSlide-this.fontConstant);
                if (hiddenSlides > 0) {
                    currentLeft -= widthSlide;
                    this.leftBody = -currentLeft;
                    var self = this;
                    this.$container.animate({
                        'left': -currentLeft,
                    }, {
                        'duration': 200,
                        'easing': 'swing',
                        'complete': function () {
                            self.animate = false;
                        }
                    });
                } else {
                    this.animate = false;
                }
            } else {
                this.animate = false;
            }
        }
    };




    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new Gallery(this, options);
        });
    };



    var old = $.fn.gallery;

    $.fn.gallery = constructor;
    $.fn.gallery.constructor = constructor;

    $.fn.gallery.noConflict = function () {
        $.fn.gallery = old;
        return this;
    }
}(jQuery);